import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
const benefits = ['Reducir el scroll automático (el que haces sin pensar)', 'Recuperar bloques de estudio sin el "tira y afloja"', 'Tener un protocolo para días malos (sin tirar el día entero)', 'Volver a sentir: "ok… sí puedo"'];
export function BenefitsSection() {
  return <section className="w-full bg-gradient-to-br from-gray-50 to-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-navy mb-6" data-id="element-4">
            Qué vas a lograr en <span className="text-teal" data-id="element-5">7 días</span>
          </h2>
        </motion.div>

        <div className="space-y-6 mb-12" data-id="element-6">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15,
          duration: 0.6
        }} className="flex items-start bg-white rounded-xl p-6 shadow-md border-2 border-gray-100 hover:border-teal transition-colors duration-300" data-id="element-7">
              <CheckCircleIcon className="w-8 h-8 text-teal flex-shrink-0 mr-4 mt-1" aria-hidden="true" data-id="element-8" />
              <p className="text-lg text-gray-800 leading-relaxed" data-id="element-9">{benefit}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8,
        duration: 0.6
      }} className="text-center bg-navy rounded-xl p-8" data-id="element-10">
          <p className="text-xl text-gray-300" data-id="element-11">
            No es magia. Es{' '}
            <span className="font-bold text-teal" data-id="element-12">
              diseño + práctica breve.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}